module.exports = __webpack_public_path__ + "img/belgium-cerebrovascular-disease-female.cad52cfe.png";